<input [formControl]="control"
       placeholder="z.B. 0664 1234567"
       i18n-placeholder="@@formField.phoneNumberInput.placeholder"
       type="tel"
       (blur)="onPhoneNumberBlur()"
       >
